var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.htmlPreview)?_c('iframe',{staticClass:"w-full h-full",attrs:{"src":"about:blank","srcdoc":_vm.htmlPreview}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }